import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { isMobile } from "react-device-detect";
import gear from "../../media/gear_white.svg";

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		logoNameContainer: {
			whiteSpace: "nowrap",
			display: "flex",
			flexDirection: "row",

			marginTop: "0px",
			width: isMobile ? "" : "380px",
		},
		nameTop: {
			marginLeft: "10px",
			marginRight: "10px",
			fontSize: "40px",
			marginTop: "28px",
			color: "white",
			fontFamily: "Roboto,Arial,Helvetica,sans-serif",
		},
		nameBottom: {
			color: "#a0b4d2",
			fontSize: "15px",
			width: "0px",
			whiteSpace: "nowrap",
			marginTop: "10px",
			marginLeft: "10px",
		},

		gear: {
			width: "45px",
			transition: "transform .7s ease-in-out",
			"&:hover": {
				transform: "rotate(360deg)",
			},
		},
		line: {
			borderLeft: "2px solid rgb(208, 208, 208)",
			height: "40px",
		},
	});
});

export const LogoNameMainPage = ({ marginLeft = "0px" }) => {
	const classes = useStyles();
	return (
		<div
			style={{ marginLeft: marginLeft }}
			className={classes.logoNameContainer}
		>
			<img src={gear} className={classes.gear}></img>
			<h1 className={classes.nameTop}>Dash AI</h1>
		</div>
	);
};
